import React from "react"
import styled from "styled-components"
import { Spinner, SpinnerProps } from "client/components"

export interface LoaderProps extends SpinnerProps {
    paddingTop?: number
}

const LoaderWrapper = styled.div<LoaderProps>`
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    padding-top: ${(props) => props.paddingTop || 50}px;
    z-index: 1;
    background: ${(props) => props.theme.spinnerBackground};
`

export const Loader = ({
    ...props
}: LoaderProps) => (
    <LoaderWrapper {...props}>
        <Spinner
            points={props.points || 12}
            pointSize={props.pointSize || 6}
            size={props.size || 64}
        />
    </LoaderWrapper>
)
